import { render } from "./loginView.vue?vue&type=template&id=5a0f4eb8&scoped=true"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import "./loginView.vue?vue&type=style&index=0&id=5a0f4eb8&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0f4eb8"]])

export default __exports__